import styled from 'styled-components';

export const ScrollHost = styled.div`
	background-color: ${({ theme }) => theme.v3.colors.gray[1]};
	overflow: auto;
	flex-grow: 1;
	display: flex;
	justify-content: center;
	padding: 1rem 0;
`;

export const PageColumn = styled.div`
	display: flex;
	flex-direction: column;
	gap: 1rem;
`;

export const PageWrapper = styled.div`
	position: relative;
`;

export const Overlay = styled.div<{ $width: number; $height: number; $inert?: boolean }>`
	position: absolute;
	top: 0;
	left: 0;
	width: ${({ $width }) => $width}px;
	height: ${({ $height }) => $height}px;
	/* Inert when another surface owns the page: the boxes stay visible for context, but every
	   click goes past them to the overlay that is actually being edited. */
	pointer-events: ${({ $inert }) => ($inert ? 'none' : 'auto')};

	& > * {
		pointer-events: ${({ $inert }) => ($inert ? 'none' : 'auto')};
	}
`;

export const DrawRect = styled.div`
	position: absolute;
	box-sizing: border-box;
	border: 2px dashed ${({ theme }) => theme.v3.colors.blue[8]};
	background-color: ${({ theme }) => theme.v3.colors.blue[1]};
	pointer-events: none;
`;
